﻿import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
    name: "relatedPersonFilter"
})
export class RelatedPersonFilterPipe implements PipeTransform {
    public transform(array: any[], eventId : number) :any {
        if (eventId > 0) {
            return _.filter(array, (row) => (row.CalendarEventId == eventId));
        } else
            return array;
    }
}
